import { configureStore } from "@reduxjs/toolkit";
import { archiveSetSliceReducer, cartReducer, catalogListNavReducer, editCategoryReducer } from "./cartSlice";

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    editCategory: editCategoryReducer,
    archiveSet: archiveSetSliceReducer,
    catalogListNav: catalogListNavReducer,
  },
});
